<template>
  <div :class="getRoleClass()">
    <el-menu
      :collapse="isCollapse"
      :collapse-transition="false"
      router
      background-color="transparent"
      text-color="#fff"
      active-text-color="#409EFF"
      :default-active="activeMenu"
      @select="handleSelect"
      style="width: 230px;"
    >
      <template v-for="item in filteredMenuList">
        <el-submenu
          v-if="item.children && item.children.length > 0 && item.id"
          :key="item.id"
          :index="String(item.path || item.authorName)"
          v-model="openedMenus"
        >
          <template slot="title">
            <i :class="iconObj[item.id]"></i>
            <span>{{ item.authorName }}</span>
          </template>

          <el-menu-item-group v-for="subItem in item.children" :key="subItem.id">
            <el-submenu v-if="subItem.children && subItem.children.length > 0" :index="String(subItem.path)" v-model="openedMenus">
              <template slot="title">
                <i :class="iconObj[subItem.id]"></i>
                <span>{{ subItem.authorName }}</span>
              </template>
              <el-menu-item v-for="subSubItem in subItem.children" :key="subSubItem.id" :index="String(subSubItem.path)">
                <router-link :to="subSubItem.path" class="menu-link">
                  <i :class="iconObj[subSubItem.id]"></i>
                  <span>{{ subSubItem.authorName }}</span>
                </router-link>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="String(subItem.path)" :key="subItem.id">
              <router-link :to="subItem.path" class="menu-link">
                <i :class="iconObj[subItem.id]"></i>
                <span>{{ subItem.authorName }}</span>
              </router-link>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-menu-item v-else :key="item.id" :index="String(item.path || item.authorName)">
          <router-link v-if="item.path" :to="item.path" class="menu-link">
            <i :class="iconObj[item.id]"></i>
            <span>{{ item.authorName }}</span>
          </router-link>
          <div v-else>
            <i :class="iconObj[item.id]"></i>
            <span>{{ item.authorName }}</span>
          </div>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rolePermissions from "@/router/permissions";

export default {
  data() {
    return {
      openedMenus: '',
      activeMenu: this.getDefaultActiveMenu(),
      menulist: [
        {
          authorName: "课程体系",
          path: null,
          children: [
            { authorName: "课程知识管理", path: "/overview", id: 5 },
            { authorName: "课程问题管理", path: "/problemGraph/probManage", id: 6 },
          ],
          id: 1,
        },
        {
          authorName: "知识图谱库",
          path: null,
          children: [
            { authorName: "知识本体建模", path: "/manage/ontology", id: 15 },
            { authorName: "知识实例管理", path: "/manage/instance", id: 16 },
          ],
          id: 2,
        },
        {
          authorName: "课程知识体系",
          path: null,
          children: [
            { authorName: "知识图谱", path: "/relation/conceptmap", id: 12 },
            { authorName: "图谱资源", path: "/relation/knowledgedisplay", id: 10 },
            { authorName: "问题图谱", path: "/problemGraph/graph", id: 11 },
          ],
          id: 3,
        },
        {
          authorName: "学生管理",
          path: "/manage/studentManage",
          id: 29,
        },
      ],
      iconObj: {
        1: "el-icon-s-management",
        2: "el-icon-coin",
        3: "el-icon-connection",
        5: "el-icon-menu",
        6: "el-icon-menu",
        10: "el-icon-menu",
        11: "el-icon-menu",
        12: "el-icon-menu",
        15: "el-icon-menu",
        16: "el-icon-menu",
        29: "el-icon-user-solid",
      },
    };
  },
  computed: {
    ...mapGetters(["isCollapse"]),
    filteredMenuList() {
      const userRole = this.userRole();
      const allowedPaths = rolePermissions[userRole] || [];

      const filterMenuItems = (items) => {
        return items
          .filter(item => {
            const isAllowed = allowedPaths.includes(item.path) ||
              (item.children && item.children.some(child => allowedPaths.includes(child.path)));
            if (!item.path && item.children) {
              return item.children.some(child => allowedPaths.includes(child.path));
            }
            return isAllowed;
          })
          .map(item => ({
            ...item,
            children: item.children ? filterMenuItems(item.children) : [],
          }));
      };

      return filterMenuItems(this.menulist);
    },
  },
  methods: {
    userRole() {
      return window.sessionStorage.getItem('userRole') || '0';
    },
    getRoleClass() {
      const role = this.userRole();
      return role === '0' ? 'menu-teacher' : role === '2' ? 'menu-student' : 'menu-default';
    },
    getDefaultActiveMenu() {
      return this.userRole() === '2' ? '/relation/stu_coneptmap' : '/overview';
    },
    handleSelect(val) {
      this.activeMenu = val;
    },
  },
};
</script>

<style lang="less">
.menu-link {
  text-decoration: none;
  color: inherit;
}

// 悬浮菜单修复
.el-menu--popup {
  margin-left: -145px !important;
  background: rgba(50, 50, 50, 0.9) !important;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
}
.el-menu--popup .el-menu-item {
  color: white !important;
  width: 200px;
}
.el-menu--popup .el-menu-item:hover {
  background: #409EFF !important;
  color: white !important;
}

// 角色样式
.menu-teacher ::v-deep(.el-menu--popup) {
  background: rgba(95, 128, 173, 0.9) !important;
}
.menu-teacher ::v-deep(.el-menu--popup .el-menu-item:hover) {
  background: rgba(95, 128, 173, 0.5) !important;
}

.menu-student ::v-deep(.el-menu--popup) {
  background: rgb(185, 18, 18) !important;
}
.menu-student ::v-deep(.el-menu--popup .el-menu-item) {
  color: blue !important;
}

.menu-default ::v-deep(.el-menu--popup) {
  background: rgba(230, 230, 230, 1) !important;
}
.menu-default ::v-deep(.el-menu--popup .el-menu-item:hover) {
  background: #dce5f1 !important;
}
</style>
